/// <amd-module name="Wit/Portal/Redux/WorkItemPortalActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IPortalWorkItem } from "Wit/Portal/Redux/WorkItemPortalContracts";

export const enum WorkItemPortalActionTypes {
    ShowWorkItem = "WorkItemPortal/ShowWorkItem",
    CloseWorkItem = "WorkItemPortal/CloseWorkItem",
    CloseNewWorkItem = "WorkItemPortal/CloseNewWorkItem"
}

export const WorkItemPortalActions = {
    showWorkItem: (workItem: IPortalWorkItem) => createAction(WorkItemPortalActionTypes.ShowWorkItem, { workItem }),
    closeWorkItem: (workItemId: number) => createAction(WorkItemPortalActionTypes.CloseWorkItem, { workItemId })
};

export type WorkItemPortalActions = ActionsUnion<typeof WorkItemPortalActions>;
